class HomeController {
  constructor() {
    "ngInject";
    this.name = 'home';

    this.images = [
      {
        url: 'images/home/slider-conf-room2.png'
      },
      {
        url: 'images/home/slider-images-reception.png'
      },
      {
        url: 'images/home/slider-group.png'
      },
      {
         url: 'images/home/slider-images-devroom.png'
      },
      {
        url: 'images/home/slider-swag-wall2.png'
      },
      {
        url: 'images/home/home-slider-pavilion-new.png'
      },
    ];
    this.services = [
      {
        icon: 'images/home/integration.svg',
        topTitle: 'enterprise',
        bottomTitle: 'integration',
        text: "We are integration experts. From CORBA to JSON to REST to Accumulo, we haven't found an integration problem that we can't solve."
      },
      {
        icon: 'images/home/development.svg',
        topTitle: 'application',
        bottomTitle: 'development',
        text: "We create software that helps our customers excel. Our experience with the latest technologies provides capabilities you never thought were possible."
      },
      {
        icon: 'images/home/modernization.svg',
        topTitle: 'software',
        bottomTitle: 'modernization',
        text: "We can evolve your existing systems safely and reliably while introducing new technologies that unlock capabilities that will take you to the next level."
      },
      {
        icon: 'images/home/management.svg',
        topTitle: 'information',
        bottomTitle: 'management',
        text: "We make information work for you. We clearly understand the difference between NoSQL and Relational and how to reap the benefits of both."
      },
      {
        icon: 'images/home/analytics.svg',
        topTitle: 'big data &',
        bottomTitle: 'analytics',
        text: "We can find your needle in almost any kind of haystack. Our experience with cutting-edge data processing technologies will get you to your solution faster."
      }
    ]

  }



}

export default HomeController;



// WEBPACK FOOTER //
// ./app/components/home/home.controller.js